import React, { useState, useEffect, Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import { httpLoginUser } from '../Hooks/user/user.post.hooks';
import AuthImage from '../Visuals/Images/Authentication.jpg';
import Auth from '../Helpers/auth';
import {
  AuthContainer,
  PictureSide,
  AuthenticationSide,
  AuthContainer2,
  AuthHeader,
} from './AuthStyles.styles';
// import { resetZoom } from '../Helpers/reset-zoom';

import HelmetHelper from '../Components/PageHelmet/HelmetHelper.component';
const PrimaryButton = React.lazy(
  () => import('../Components/Buttons/PrimaryButton/PrimaryButton.component')
);
const InputContainer = React.lazy(() => import('../Components/Form/Input'));
const PasswordInput = React.lazy(
  () => import('../Components/Form/PasswordInput')
);
const LoginOptions = React.lazy(() => import('./LoginOptions.component'));

// Form for login
const LoginComponent = () => {
  const navigate = useNavigate();
  const [showPass, setShowPass] = useState(false);
  const [formState, setFormState] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormState({
      ...formState,
      [name]: value,
    });
    if (error.length) {
      setError('');
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const trimmedEmail = formState.email.trim();
    const trimmedPassword = formState.password.trim();

    if (trimmedEmail.length < 6 || !trimmedEmail.includes('@')) {
      setError('Not a valid email');
      return;
    }
    if (trimmedPassword.length < 6) {
      setError('Password is not valid');
      return;
    }
    setIsSubmitting(true);
    const response = await httpLoginUser({
      email: trimmedEmail,
      password: trimmedPassword,
    });
    const data = await response.json();
    if (response.ok) {
      Auth.login(data.token);
      setFormState({
        email: '',
        password: '',
      });
    } else {
      setError(data.msg || 'An error occurred');
      return;
    }
  };

  useEffect(() => {
    if (isSubmitting && Auth.getToken() !== null) {
      navigate('/user');
    }
  });

  return (
    <AuthContainer>
      <HelmetHelper
        title="Login"
        description="Log in to access your online training, course progress, certificates, and account."
        noIndex
      />
      <AuthContainer2>
        <PictureSide>
          <img src={AuthImage} loading="eager" alt="Yellow helmets" />
        </PictureSide>

        <AuthenticationSide>
          <Suspense fallback={<div>Loading...</div>}>
            <form onSubmit={handleFormSubmit}>
              <AuthHeader>
                {/* <p className="eyebrowHeader">Welcome Back</p> */}
                <h2>Login</h2>
                <p>
                  Access your courses, training records, certificates, and
                  account details.
                </p>
              </AuthHeader>

              <InputContainer
                placeholder="yoda@safety.com"
                label="Email"
                value={formState.email}
                name="email"
                onChange={handleChange}
              />

              <PasswordInput
                label="Password"
                span="Must be at least 6 characters"
                handleChange={(e) => {
                  e.preventDefault();
                  setShowPass((prev) => !prev);
                }}
                showPass={showPass}
                value={formState.password}
                name="password"
                onChange={handleChange}
              />

              {error && <p className="error">{error}</p>}

              <PrimaryButton span="Login" />
            </form>

            <LoginOptions />
          </Suspense>
        </AuthenticationSide>
      </AuthContainer2>
    </AuthContainer>
  );
};

export default LoginComponent;
